import axios from 'axios';
import AuthTokenService from '@/services/authToken';

const apiIntercenpter = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true, // ✅ enable cookie sending  
  headers: {
    'Content-Type': 'application/json',
  },
});

apiIntercenpter.interceptors.request.use(
  async (config) => {
    let token = ''
    // token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY0ZGUyNGVlY2I5NjlkOTQwMTE1MDg0OCIsInR5cGUiOiJhdXRoIiwiZGV2aWNlVHlwZSI6IndlYiIsImlhdCI6MTc0NzA3MzQ5MywiZXhwIjoxNzQ3MTU5ODkzfQ.g89UTwcf2GANd-UZjEGNcBCtkMVdonIwaj6M9BrMq8A";
    token = await AuthTokenService.ensureValidToken();
    // debugger
    if (token != '') {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default apiIntercenpter;
